import { DataUserResponse } from '@dealstack/shared/lib/generated';
import { createAction, createReducer } from '@reduxjs/toolkit';

export interface UserState {
	isLoading: boolean;
	data: DataUserResponse | null;
}

export interface UserName {
	firstName: string;
	lastName: string;
}

export const fetchUserStart = createAction('user/getData/start');
export const fetchUserSuccess = createAction<DataUserResponse>('user/getData/success');
export const fetchUserError = createAction<unknown>('user/getData/error');
export const userNameUpdated = createAction<UserName>('user/nameUpdated');
export const logout = createAction('user/logout');

/** Mutates a draft user in place; shared by the admin and investor user reducers. */
export const applyUserName = (data: DataUserResponse | null, { firstName, lastName }: UserName) => {
	if (!data) {
		return;
	}
	data.firstName = firstName;
	data.lastName = lastName;
	if (data.person) {
		data.person.firstName = firstName;
		data.person.lastName = lastName;
	}
};

const initialState = {
	isLoading: false,
	data: null,
} as UserState;

// https://redux-toolkit.js.org/api/createReducer
export const userReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(fetchUserStart, (state) => {
			state.isLoading = true;
		})
		.addCase(fetchUserSuccess, (state, action) => {
			state.data = action.payload;
			state.isLoading = false;
		})
		.addCase(fetchUserError, (state) => {
			state.isLoading = false;
		})
		.addCase(userNameUpdated, (state, action) => {
			applyUserName(state.data, action.payload);
		})
		.addCase(logout, (state) => {
			state.isLoading = false;
			state.data = null;
		});
});
